<div class="row">
  <div class="col-12 px-md-2">
    <div class="card bg-white rounded-0 border-start-0 border-end-0">
      <div class="d-flex align-items-center px-2">
        <div class="d-flex flex-column w-100">
          <div class="d-flex flex-row align-items-center w-100 py-2">
            <h2 class="h4 mb-0 me-3">Awards</h2>
            <div class="flex-grow-1">
              <div class="d-flex flex-row align-items-center">
                <div class="d-flex gap-4">
                  <div class="text-muted small">
                    <strong>{{ totalSuppliers }}</strong> suppliers with
                    <strong>{{ totalOffers }}</strong> awarded offers
                  </div>
                  <div class="text-muted small" *ngIf="getTotalAwardedVolume() > 0">
                    Total Volume: <strong>{{ getTotalAwardedVolume() | number:'1.0-0' }} {{ getTenderUnits() }}</strong>
                  </div>
                </div>
              </div>
            </div>

            <div class="ms-auto d-flex align-items-center gap-2">
              <button *ngIf="canSendConfirmationReminder"
                      class="btn btn-outline-primary btn-sm"
                      (click)="openConfirmationReminderModal(confirmationReminderModal)"
                      [disabled]="sendingConfirmationReminder">
                <span *ngIf="sendingConfirmationReminder" class="spinner-border spinner-border-sm me-1" role="status">
                  <span class="visually-hidden">Sending...</span>
                </span>
                <ng-icon *ngIf="!sendingConfirmationReminder" name="lucideMailCheck" class="me-1"></ng-icon>
                Remind {{ unconfirmedSupplierCount }} supplier{{ unconfirmedSupplierCount === 1 ? '' : 's' }} to confirm
              </button>
              <button class="btn btn-light btn-sm" (click)="exportAwards()" [disabled]="exporting">
                <span *ngIf="exporting" class="spinner-border spinner-border-sm me-1" role="status">
                  <span class="visually-hidden">Exporting...</span>
                </span>
                <ng-icon *ngIf="!exporting" name="lucideDownload" class="me-1"></ng-icon>
                {{ exporting ? 'Exporting...' : 'Export to Excel' }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Search and Filters -->
<div class="row">
  <div class="col-12 px-md-2">
    <div class="card bg-white rounded-0 border-start-0 border-end-0 border-top-0 mb-3">
      <div class="card-body py-2">
        <div class="d-flex flex-wrap gap-2 align-items-center">
          <!-- Search -->
          <div style="width: 240px;">
            <div class="input-group input-group-sm">
              <span class="input-group-text">
                <ng-icon name="lucideSearch"></ng-icon>
              </span>
              <input type="text" id="searchTerm" aria-label="Search" class="form-control"
                placeholder="Search by location or supplier..." [(ngModel)]="searchTerm" (input)="onSearchChange()">
            </div>
          </div>

          <!-- Award Status Filter -->
          <div>
            <div class="input-group input-group-sm">
              <span class="input-group-text">
                <ng-icon name="lucideListFilterPlus" class="me-1"></ng-icon>
                Status
              </span>
              <select id="statusFilter" class="form-select" [(ngModel)]="statusFilter" (change)="onFilterChange()">
                <option value="">All Statuses</option>
                <option value="TENTATIVE_AWARDED">Tentatively Awarded</option>
                <option value="AWARDED">Awarded</option>
              </select>
            </div>
          </div>

          <!-- Notification Status Filter -->
          <div>
            <div class="input-group input-group-sm">
              <span class="input-group-text">
                <ng-icon name="lucideListFilterPlus" class="me-1"></ng-icon>
                Notifications
              </span>
              <select id="notificationFilter" class="form-select" [(ngModel)]="notificationFilter"
                (change)="onFilterChange()">
                <option value="">All Suppliers</option>
                <option value="notified">Notified</option>
                <option value="not_notified">Not Notified</option>
              </select>
            </div>
          </div>

          <div *ngIf="locationTagOptions.length > 0" style="min-width: 200px;">
            <ng-select
                [items]="locationTagOptions"
                [multiple]="true"
                [clearable]="true"
                bindLabel="name"
                bindValue="id"
                placeholder="Filter by Location Tags..."
                [(ngModel)]="selectedLocationTags"
                (ngModelChange)="onLocationTagFilterChange()"
                class="filter-select">
            </ng-select>
          </div>

          <!-- Actions -->
          <div>
            <button class="btn btn-light btn-sm" (click)="clearFilters()">
              <ng-icon name="lucideX" class="me-1"></ng-icon>
              Clear Filters
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Awards Content -->
<div [class.opacity-50]="loading" [class.pe-none]="loading" style="position: relative;">

  <!-- Loading Overlay -->
  <div *ngIf="loading" style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); z-index: 10;">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>

  <!-- No Awards Message -->
  <div class="row">
    <div class="col-12" *ngIf="supplierGroups.length === 0">
      <div class="card bg-white">
        <div class="row">
          <div class="col-12 px-md-2">
            <div class="card-body text-center py-5">
              <ng-icon name="lucideAward" size="48" class="text-muted mb-3"></ng-icon>
              <h5 class="text-muted">No Awards Found</h5>
              <p class="text-muted mb-0">
                No suppliers have been awarded yet.
                Go to the <a class="fw-bold" [routerLink]="['/tenders', tender.id, 'locations']">Locations</a> page to
                start
                awarding bids.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngFor="let supplierGroup of supplierGroups; let i = index; trackBy: trackBySupplierGroup" class="col-12">
      <!-- Supplier Groups -->
      <div class="card bg-white rounded-0 border-start-0 border-end-0 mb-4">

        <!-- Supplier Header -->
        <div class="card-header bg-light border-bottom px-2">
          <div class="d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
              <h5 class="h4 mb-0 me-3 text-primary">{{ supplierGroup.supplier.name }}<span *ngIf="supplierGroup.supplier.supplier_alias"> ({{ supplierGroup.supplier.supplier_alias }})</span></h5>
              <span class="badge bg-light text-muted border me-2">{{ supplierGroup.total_offers }} offers</span>
              <span class="badge bg-light text-muted border" *ngIf="supplierGroup.total_awarded_volume > 0">
                {{ supplierGroup.total_awarded_volume | number:'1.0-0' }} {{ getTenderUnits() }}
              </span>
            </div>

            <div class="d-flex align-items-center gap-2">
              <!-- Confirm Awards Button (only if tentatively awarded offers exist) -->
              <button *ngIf="user.canManage(tender) && hasTentativelyAwardedOffers(supplierGroup)" class="btn btn-outline-primary btn-sm"
                (click)="confirmSupplierAwards(supplierGroup)">
                <ng-icon name="lucideCheck" class="me-1"></ng-icon>
                Confirm Awards
              </button>

              <!-- Notification Status Badge (only if notification has been sent) -->
              <button *ngIf="hasNotificationBeenSent(supplierGroup)" class="btn btn-outline-primary text-secondary btn-sm"
                [popoverTitle]="awardNotificationPopoverTitle" [ngbPopover]="awardNotificationPopoverTemplate"
                placement="top" container="body" triggers="mouseenter:mouseleave"
                (mouseenter)="setCurrentSupplierGroup(supplierGroup)">
                <ng-icon name="lucideCircleCheckBig"></ng-icon>
              </button>

              <!-- Notify Supplier Button (only if awarded offers exist) -->
              <button *ngIf="user.canManage(tender) && hasAwardedOffers(supplierGroup)" class="btn btn-outline-primary btn-sm"
                (click)="notifySupplier(supplierGroup)" [disabled]="!hasAwardedOffers(supplierGroup)">
                <ng-icon name="lucideMail" class="me-1"></ng-icon>
                {{ getNotificationButtonText(supplierGroup) }}
              </button>
            </div>
          </div>
        </div>

        <!-- Offers Table -->
        <div class="table-responsive">
          <table class="table table-hover mb-0">
            <thead class="table-light">
              <tr>
                <th class="col-location">
                  <a href="javascript:void(0)" (click)="sort($event, 'location')">
                    Location
                    <ng-icon *ngIf="orderField === 'location'"
                      [name]="order === 'ASC' ? 'lucideChevronUp' : 'lucideChevronDown'" class="ms-1">
                    </ng-icon>
                  </a>
                </th>
                <th class="col-company-info" *ngIf="!tender.company.settings.isHiddenField('location_company_info')">
                  {{ tender.company.settings.getFieldName('location_company_info', 'Company Info') }}
                </th>
                <th class="col-fuel-type" *ngIf="!tender.company.settings.isHiddenField('location_fuel_type')">
                  <a href="javascript:void(0)" (click)="sort($event, 'fuel_type')">
                    {{ tender.company.settings.getFieldName('location_fuel_type', 'Fuel Type') }}
                    <ng-icon *ngIf="orderField === 'fuel_type'"
                      [name]="order === 'ASC' ? 'lucideChevronUp' : 'lucideChevronDown'" class="ms-1">
                    </ng-icon>
                  </a>
                </th>
                <th class="col-flight-type" *ngIf="!tender.company.settings.isHiddenField('location_flight_type')">
                  <a href="javascript:void(0)" (click)="sort($event, 'flight_type')">
                    {{ tender.company.settings.getFieldName('location_flight_type', 'Flight Type') }}
                    <ng-icon *ngIf="orderField === 'flight_type'"
                      [name]="order === 'ASC' ? 'lucideChevronUp' : 'lucideChevronDown'" class="ms-1">
                    </ng-icon>
                  </a>
                </th>
                <th class="col-delivery-point" *ngIf="!tender.company.settings.isHiddenField('location_delivery_point')">
                  {{ tender.company.settings.getFieldName('location_delivery_point', 'Delivery Point') }}
                </th>
                <th class="col-total-volume" *ngIf="!tender.company.settings.isHiddenField('location_contract_volume')">
                  {{ tender.company.settings.getFieldName('location_contract_volume', 'Total Volume') }}
                </th>
                <th class="col-awarded-volume">
                  <a href="javascript:void(0)" (click)="sort($event, 'awarded_volume')">
                    Awarded Volume
                    <ng-icon *ngIf="orderField === 'awarded_volume'"
                      [name]="order === 'ASC' ? 'lucideChevronUp' : 'lucideChevronDown'" class="ms-1">
                    </ng-icon>
                  </a>
                </th>
                <th class="col-contract-start">
                  <a href="javascript:void(0)" (click)="sort($event, 'contract_start')">
                    {{ tender.company.settings.getFieldName('location_contract_start_date', 'Contract Start') }}
                    <ng-icon *ngIf="orderField === 'contract_start'"
                      [name]="order === 'ASC' ? 'lucideChevronUp' : 'lucideChevronDown'" class="ms-1">
                    </ng-icon>
                  </a>
                </th>
                <th class="col-contract-end">
                  <a href="javascript:void(0)" (click)="sort($event, 'contract_end')">
                    {{ tender.company.settings.getFieldName('location_contract_end_date', 'Contract End') }}
                    <ng-icon *ngIf="orderField === 'contract_end'"
                      [name]="order === 'ASC' ? 'lucideChevronUp' : 'lucideChevronDown'" class="ms-1">
                    </ng-icon>
                  </a>
                </th>
                <th class="col-contract-type">
                  Contract Type
                </th>
                <th class="col-comment">Comment</th>
                <th class="col-status">Status</th>
                <th class="col-actions">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let offer of supplierGroup.offers; trackBy: trackByOffer">
                <td>
                  <div class="d-flex align-items-center">
                    <strong [ngbTooltip]="offer.location_name" placement="right" container="body">
                      {{ offer.location_iata }}
                    </strong>
                  </div>
                </td>
                <td *ngIf="!tender.company.settings.isHiddenField('location_company_info')">
                  <span *ngIf="offer.company_child && offer.company_child.name">
                    {{ offer.company_child.alias || offer.company_child.name }}
                  </span>
                  <span *ngIf="!offer.company_child || !offer.company_child.name">
                    {{ offer.company_info || '-' }}
                  </span>
                </td>
                <td *ngIf="!tender.company.settings.isHiddenField('location_fuel_type')">
                  {{ tender.company.settings.getFilteredOptionLabel('fuel_type', offer.fuel_type) || '-' }}
                </td>
                <td *ngIf="!tender.company.settings.isHiddenField('location_flight_type')">
                  {{ offer.flight_type?.name || '-' }}
                </td>
                <td *ngIf="!tender.company.settings.isHiddenField('location_delivery_point')">
                  {{ tender.company.settings.getFilteredOptionLabel('delivery_point', offer.delivery_point) || '-' }}
                </td>
                <td *ngIf="!tender.company.settings.isHiddenField('location_contract_volume')">
                  <span *ngIf="offer.volume">
                    {{ offer.volume | number:'1.0-0' }} {{ offer.units?.code }}
                  </span>
                  <span *ngIf="!offer.volume" class="text-muted">-</span>
                </td>
                <td>
                  <span *ngIf="offer.awarded_volume">
                    {{ offer.awarded_volume | number:'1.0-0' }} {{ offer.units?.code }}
                  </span>
                  <span *ngIf="!offer.awarded_volume" class="text-muted">-</span>
                  <span class="badge bg-light text-muted border ms-1">
                    {{ offer.awarded_percent || 0 | number:'1.0-0' }}%
                  </span>
                </td>
                <td>
                  <span *ngIf="getContractStartDate(offer)">
                    {{ getContractStartDate(offer) }}
                  </span>
                  <span *ngIf="!getContractStartDate(offer)" class="text-muted">-</span>
                </td>
                <td>
                  <span *ngIf="getContractEndDate(offer)">
                    {{ getContractEndDate(offer) }}
                  </span>
                  <span *ngIf="!getContractEndDate(offer)" class="text-muted">-</span>
                </td>
                <td>
                  {{ offer.contract_type || '-' }}
                </td>
                <td>
                  <jft-award-comment-icon [comment]="offer.award_comment"
                    [airline]="$safeNavigationMigration(tender?.company?.name)"></jft-award-comment-icon>
                  <span *ngIf="!offer.award_comment" class="text-muted">-</span>
                </td>
                <td>
                  <jft-offer-status [status]="offer.status" [awardedPercent]="offer.awarded_percent"></jft-offer-status>
                </td>
                <td>
                  <div class="d-flex align-items-center justify-content-end">
                    <div *ngIf="user.canManage(tender)" ngbDropdown container="body" placement="bottom-end" class="d-inline-block">
                      <button type="button" class="btn btn-outline-secondary btn-sm" ngbDropdownToggle>
                        <i class="fas fa-ellipsis-v"></i>
                      </button>
                      <div ngbDropdownMenu>
                        <!-- Confirm Award (only for tentatively awarded) -->
                        <button *ngIf="offer.status === 'TENTATIVE_AWARDED'" ngbDropdownItem
                          (click)="confirmAward(offer)">
                          <ng-icon name="lucideCheck" class="me-2 text-muted"></ng-icon> Confirm Award
                        </button>

                        <!-- Cancel Tentative Award -->
                        <button *ngIf="offer.status === 'TENTATIVE_AWARDED'" ngbDropdownItem
                          (click)="cancelTentativeAward(offer)">
                          <ng-icon name="lucideX" class="me-2 text-muted"></ng-icon> Cancel Tentative
                        </button>

                        <!-- Cancel Award (only for awarded) -->
                        <button *ngIf="offer.status === 'AWARDED'" ngbDropdownItem (click)="cancelAward(offer)">
                          <ng-icon name="lucideX" class="me-2 text-muted"></ng-icon> Cancel Award
                        </button>

                        <!-- Edit Award -->
                        <button ngbDropdownItem (click)="editAward(offer)">
                          <ng-icon name="lucidePencil" class="me-2 text-muted"></ng-icon> Edit Award
                        </button>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>

</div>

<!-- Notification Popover Template -->
<ng-template #awardNotificationPopoverTitle>Award Notification Sent</ng-template>
<ng-template #awardNotificationPopoverTemplate>
  <div *ngIf="currentSupplierGroup && hasNotificationBeenSent(currentSupplierGroup)" class="notification-popover">
    <div class="mb-2">
      Supplier: <strong>{{ getNotificationSupplierName(currentSupplierGroup) }}<span *ngIf="currentSupplierGroup?.supplier?.supplier_alias"> ({{ currentSupplierGroup.supplier.supplier_alias }})</span></strong>
    </div>
    <div class="mb-0">
      Email Sent: <strong>{{ getNotificationSentTime(currentSupplierGroup) }}</strong>
    </div>
    <!-- <div *ngIf="getNotificationEmails(currentSupplierGroup).length > 0">
      <div class="mb-1 small"><strong>Recipients:</strong></div>
      <table class="table table-sm table-borderless mb-0">
        <tbody>
          <tr *ngFor="let email of getNotificationEmails(currentSupplierGroup)">
            <td class="py-1 px-0 small">{{ email }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div *ngIf="getNotificationEmails(currentSupplierGroup).length === 0" class="text-muted small">
      No active users found
    </div> -->
  </div>
</ng-template>

<!-- Confirm Award Modal -->
<ng-template #confirmAwardModal let-modal>
  <div class="modal-header bg-dark text-white">
    <h4 class="modal-title">Confirm Award</h4>
    <button type="button" class="btn-close btn-close-white" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <ng-container *ngIf="offerToConfirm">

    <!-- Location Information Card -->
    <div class="card mb-3">
      <div class="card-header bg-light">
        <h6 class="card-title mb-0">
          <ng-icon name="lucideMapPin" class="me-2"></ng-icon>
          Location Information
        </h6>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-3 mb-2">
            <div class="text-muted small">Location</div>
            <div class="fw-bold">{{offerToConfirm?.location_name}}</div>
          </div>
          <div class="col-md-3 mb-2" *ngIf="!tender?.company?.settings?.isHiddenField('location_company')">
            <div class="text-muted small">Company Info</div>
            <div class="fw-bold">{{offerToConfirm?.company_info || 'N/A'}}</div>
          </div>
          <div class="col-md-3 mb-2" *ngIf="!tender?.company?.settings?.isHiddenField('location_fuel_type')">
            <div class="text-muted small">Fuel Type</div>
            <div class="fw-bold">{{offerToConfirm?.fuel_type?.name || offerToConfirm?.fuel_type || 'N/A'}}</div>
          </div>
          <div class="col-md-3 mb-2" *ngIf="!tender?.company?.settings?.isHiddenField('location_flight_type')">
            <div class="text-muted small">Flight Type</div>
            <div class="fw-bold">{{offerToConfirm?.flight_type?.name || offerToConfirm?.flight_type || 'N/A'}}</div>
          </div>
          <div class="col-md-3 mb-2"
            *ngIf="!tender?.company?.settings?.isHiddenField('location_delivery_point')">
            <div class="text-muted small">Preferred Delivery Point</div>
            <div class="fw-bold">{{offerToConfirm?.delivery_point || 'N/A'}}</div>
          </div>
          <div class="col-md-3 mb-2">
            <div class="text-muted small">Total Volume</div>
            <div class="fw-bold">{{$safeNavigationMigration(offerToConfirm?.volume) | number:'1.0-0'}} {{offerToConfirm?.units?.code}}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- Tentative Award Information Card -->
    <div class="card mb-3">
      <div class="card-header bg-light">
        <h6 class="card-title mb-0">
          <ng-icon name="lucideBuilding2" class="me-2"></ng-icon>
          Tentative Award Information
        </h6>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-3 mb-2">
            <div class="text-muted small">Supplier</div>
            <div class="fw-bold">{{getSupplierGroupForOffer(offerToConfirm)?.supplier?.name || 'N/A'}}<span *ngIf="getSupplierGroupForOffer(offerToConfirm)?.supplier?.supplier_alias"> ({{getSupplierGroupForOffer(offerToConfirm)?.supplier?.supplier_alias}})</span></div>
          </div>
          <div class="col-md-3 mb-2">
            <div class="text-muted small">Awarded Contract Volume</div>
            <div class="fw-bold">{{$safeNavigationMigration(offerToConfirm?.awarded_volume) | number:'1.0-0'}} {{offerToConfirm?.units?.code}}
            </div>
          </div>
          <div class="col-md-3 mb-2">
            <div class="text-muted small">Award Percentage</div>
            <div class="fw-bold">{{offerToConfirm?.awarded_percent}}%</div>
          </div>
          <div class="col-md-3 mb-2">
            <div class="text-muted small">Contract Type</div>
            <div class="fw-bold">{{offerToConfirm?.contract_type}}</div>
          </div>
          <div class="col-md-3 mb-2">
            <div class="text-muted small">Contract Start</div>
            <div class="fw-bold">{{getContractStartDate(offerToConfirm)}}</div>
          </div>
          <div class="col-md-3 mb-2">
            <div class="text-muted small">Contract End</div>
            <div class="fw-bold">{{getContractEndDate(offerToConfirm)}}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- Award Comment (editable: confirming is when the supplier starts seeing it) -->
    <div class="card mb-3">
      <div class="card-header bg-light d-flex align-items-center">
        <h6 class="card-title mb-0 flex-grow-1">
          <ng-icon name="lucideMessageSquare" class="me-2"></ng-icon>
          Award Comment
        </h6>
        <span class="badge bg-warning-subtle text-dark border border-warning-subtle fw-normal">
          Visible to the supplier
        </span>
      </div>
      <div class="card-body">
        <textarea class="form-control" rows="3" [(ngModel)]="confirmAwardComment"
          [maxlength]="awardCommentMaxLength" [disabled]="confirmingAward"
          placeholder="Optional. e.g. Volume ramps up from Q2 &mdash; please countersign by Friday."></textarea>
        <div class="d-flex justify-content-between small text-muted mt-1">
          <span>
            {{getSupplierGroupForOffer(offerToConfirm)?.supplier?.name || 'The supplier'}} will read this on their
            Tender Results page and in the award notification email once you confirm.
          </span>
          <span class="text-nowrap ms-2">
            {{ (confirmAwardComment || '').length }}/{{ awardCommentMaxLength }}
          </span>
        </div>
      </div>
    </div>

    <div class="alert alert-primary">
      <ng-icon name="lucideInfo" class="me-2"></ng-icon>
      <strong>Note:</strong> This action will finalize the award. Supplier will be able to see the award but will not be
      notified via email. Notifications need to be sent manually via the "Notify Supplier" button.
    </div>
    </ng-container>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-light me-3" (click)="modal.dismiss()"
      [disabled]="confirmingAward">Cancel</button>
    <button type="button" class="btn btn-dark" (click)="confirmAwardAction()" [disabled]="!offerToConfirm || confirmingAward">
      <span *ngIf="confirmingAward">
        <div class="spinner-border spinner-border-sm me-1" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        <span>Confirming...</span>
      </span>
      <span *ngIf="!confirmingAward">Confirm Award</span>
    </button>
  </div>
</ng-template>

<!-- Cancel Tentative Award Modal -->
<ng-template #cancelTentativeAwardModal let-modal>
  <div class="modal-header bg-danger text-white">
    <h4 class="modal-title">Cancel Tentative Award</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <p class="mb-4">
      Are you sure you want to cancel the tentative award for <strong>{{offerToCancel?.location_iata}}</strong>
      from <strong>{{getSupplierGroupForOffer(offerToCancel)?.supplier?.name}}<span *ngIf="getSupplierGroupForOffer(offerToCancel)?.supplier?.supplier_alias"> ({{getSupplierGroupForOffer(offerToCancel)?.supplier?.supplier_alias}})</span></strong>?
    </p>

    <!-- Location Information Card -->
    <div class="card mb-3">
      <div class="card-header bg-light">
        <h6 class="card-title mb-0">
          <ng-icon name="lucideMapPin" class="me-2"></ng-icon>
          Location Information
        </h6>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-3 mb-2">
            <div class="text-muted small">Location</div>
            <div class="fw-bold">{{offerToCancel?.location_name}}</div>
          </div>
          <div class="col-md-3 mb-2" *ngIf="!tender?.company?.settings?.isHiddenField('location_company')">
            <div class="text-muted small">Company Info</div>
            <div class="fw-bold">{{offerToCancel?.company_info || 'N/A'}}</div>
          </div>
          <div class="col-md-3 mb-2" *ngIf="!tender?.company?.settings?.isHiddenField('location_fuel_type')">
            <div class="text-muted small">Fuel Type</div>
            <div class="fw-bold">{{offerToCancel?.fuel_type?.name || offerToCancel?.fuel_type || 'N/A'}}</div>
          </div>
          <div class="col-md-3 mb-2" *ngIf="!tender?.company?.settings?.isHiddenField('location_flight_type')">
            <div class="text-muted small">Flight Type</div>
            <div class="fw-bold">{{offerToCancel?.flight_type?.name || offerToCancel?.flight_type || 'N/A'}}</div>
          </div>
          <div class="col-md-3 mb-2"
            *ngIf="!tender?.company?.settings?.isHiddenField('location_delivery_point')">
            <div class="text-muted small">Preferred Delivery Point</div>
            <div class="fw-bold">{{offerToCancel?.delivery_point || 'N/A'}}</div>
          </div>
          <div class="col-md-3 mb-2">
            <div class="text-muted small">Total Volume</div>
            <div class="fw-bold">{{$safeNavigationMigration(offerToCancel?.volume) | number:'1.0-0'}} {{offerToCancel?.units?.code}}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- Tentative Award Information Card -->
    <div class="card mb-3">
      <div class="card-header bg-light">
        <h6 class="card-title mb-0">
          <ng-icon name="lucideBuilding2" class="me-2"></ng-icon>
          Tentative Award Information
        </h6>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-3 mb-2">
            <div class="text-muted small">Supplier</div>
            <div class="fw-bold">{{getSupplierGroupForOffer(offerToCancel)?.supplier?.name || 'N/A'}}<span *ngIf="getSupplierGroupForOffer(offerToCancel)?.supplier?.supplier_alias"> ({{getSupplierGroupForOffer(offerToCancel)?.supplier?.supplier_alias}})</span></div>
          </div>
          <div class="col-md-3 mb-2">
            <div class="text-muted small">Awarded Contract Volume</div>
            <div class="fw-bold">{{$safeNavigationMigration(offerToCancel?.awarded_volume) | number:'1.0-0'}} {{offerToCancel?.units?.code}}</div>
          </div>
          <div class="col-md-3 mb-2">
            <div class="text-muted small">Award Percentage</div>
            <div class="fw-bold">{{offerToCancel?.awarded_percent}}%</div>
          </div>
          <div class="col-md-3 mb-2">
            <div class="text-muted small">Contract Type</div>
            <div class="fw-bold">{{offerToCancel?.contract_type}}</div>
          </div>
          <div class="col-md-3 mb-2">
            <div class="text-muted small">Contract Start</div>
            <div class="fw-bold">{{getContractStartDate(offerToCancel)}}</div>
          </div>
          <div class="col-md-3 mb-2">
            <div class="text-muted small">Contract End</div>
            <div class="fw-bold">{{getContractEndDate(offerToCancel)}}</div>
          </div>
        </div>
      </div>
    </div>

    <ng-container *ngTemplateOutlet="awardCommentReadOnly; context: {$implicit: offerToCancel}"></ng-container>

    <div class="alert alert-danger">
      <ng-icon name="lucideTriangleAlert" class="me-2"></ng-icon>
      <strong>Warning:</strong> This will revert the offer back to 'Received' status and the supplier will not be
      notified.
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-light me-3" (click)="modal.dismiss()"
      [disabled]="cancellingAward">Cancel</button>
    <button type="button" class="btn btn-danger" (click)="cancelTentativeAwardAction()" [disabled]="cancellingAward">
      <span *ngIf="cancellingAward">
        <div class="spinner-border spinner-border-sm me-1" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        <span>Cancelling...</span>
      </span>
      <span *ngIf="!cancellingAward">Cancel Tentative Award</span>
    </button>
  </div>
</ng-template>

<!-- Confirm Bulk Tentative Awards Modal -->
<ng-template #confirmBulkTentativeModal let-modal>
  <div class="modal-header bg-dark text-white">
    <h4 class="modal-title">Confirm Tentative Awards</h4>
    <button type="button" class="btn-close btn-close-white" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">

    <!-- Supplier Information Card -->
    <div class="card mb-3">
      <div class="card-header bg-light">
        <h6 class="card-title mb-0">
          <ng-icon name="lucideBuilding2" class="me-2"></ng-icon>
          Supplier Information
        </h6>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-6 mb-2">
            <div class="text-muted small">Company Name</div>
            <div class="fw-bold">{{bulkConfirmSupplier?.name || 'N/A'}}<span *ngIf="bulkConfirmSupplier?.supplier_alias"> ({{bulkConfirmSupplier?.supplier_alias}})</span></div>
          </div>
          <div class="col-md-6 mb-2">
            <div class="text-muted small">Total Tentative Awards</div>
            <div class="fw-bold">{{bulkConfirmCount}} locations</div>
          </div>
        </div>
      </div>
    </div>

    <!-- Tentative Award Locations -->
    <div class="card mb-3">
      <div class="card-header bg-light">
        <h6 class="card-title mb-0">
          <ng-icon name="lucideMapPin" class="me-2"></ng-icon>
          Locations to be Confirmed
        </h6>
      </div>
      <div class="table-responsive">
        <table class="table table-sm mb-0">
          <thead class="table-light">
            <tr>
              <th>Location</th>
              <th *ngIf="!tender?.company?.settings?.isHiddenField('location_company_info')">Company Info</th>
              <th *ngIf="!tender?.company?.settings?.isHiddenField('location_fuel_type')">Fuel Type</th>
              <th *ngIf="!tender?.company?.settings?.isHiddenField('location_flight_type')">Flight Type</th>
              <th>Awarded Contract Volume</th>
              <th>Contract Period</th>
              <th>Comment</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let offer of bulkTentativeOffers; trackBy: trackByOffer">
              <td>
                <strong>{{offer.location_iata || 'N/A'}}</strong><br>
                <small class="text-muted">{{offer.location_name || 'N/A'}}</small>
              </td>
              <td *ngIf="!tender?.company?.settings?.isHiddenField('location_company_info')">
                {{offer.company_info || 'N/A'}}
              </td>
              <td *ngIf="!tender?.company?.settings?.isHiddenField('location_fuel_type')">
                <span class="">{{tender.company.settings.getFilteredOptionLabel('fuel_type', offer.fuel_type) ||
                  offer.fuel_type || 'N/A'}}</span>
              </td>
              <td *ngIf="!tender?.company?.settings?.isHiddenField('location_flight_type')">
                <span class="">{{offer.flight_type?.name || 'N/A'}}</span>
              </td>
              <td>
                <strong>{{getAwardedVolumeFormatted(offer)}}</strong><br>
                <small class="text-muted">{{offer.units?.code || ''}}</small>
              </td>
              <td>
                <div class="small">
                  <div><strong>Start:</strong> {{getContractStartDate(offer) || 'N/A'}}</div>
                  <div><strong>End:</strong> {{getContractEndDate(offer) || 'N/A'}}</div>
                </div>
              </td>
              <td>
                <jft-award-comment-icon [comment]="offer.award_comment"
                  [airline]="$safeNavigationMigration(tender?.company?.name)"></jft-award-comment-icon>
                <span class="text-muted" *ngIf="!offer.award_comment">-</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="alert alert-primary" *ngIf="hasBulkAwardComments">
      <ng-icon name="lucideInfo" class="me-2"></ng-icon>
      The award comments above are shown to the supplier once these awards are confirmed. Use
      <strong>Edit Award</strong> on a location to change its comment.
    </div>

    <div class="alert alert-primary">
      <p><ng-icon name="lucideTriangleAlert" class="me-2"></ng-icon>
        This action will finalize the award for all the listed offers. Supplier will be able to see the award on Jet
        Fuel Tenders,but will not be notified via email.</p>
      <p class="mb-0">Notifications need to be sent manually via the "Notify Supplier" button. </p>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-light me-3" (click)="modal.dismiss()"
      [disabled]="confirmingBulkAwards">Cancel</button>
    <button type="button" class="btn btn-dark" (click)="confirmBulkTentativeAction()" [disabled]="confirmingBulkAwards">
      <span *ngIf="confirmingBulkAwards">
        <div class="spinner-border spinner-border-sm me-1" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        <span>Confirming...</span>
      </span>
      <span *ngIf="!confirmingBulkAwards">Confirm {{bulkConfirmCount}} Awards</span>
    </button>
  </div>
</ng-template>

<!-- Notification Validation Modal -->
<ng-template #notificationValidationModal let-modal>
  <div class="modal-header bg-danger text-white">
    <h4 class="modal-title">Cannot Send Notification</h4>
    <div class="ms-auto" data-bs-theme="dark">
      <button type="button" class="btn-close btn-close-white" aria-label="Close" (click)="modal.dismiss()"></button>
    </div>
  </div>
  <div class="modal-body">
    <div class="alert alert-danger mb-4">
      <ng-icon name="lucideTriangleAlert" class="me-2"></ng-icon>
      <strong>Notification cannot be sent if some locations are not fully awarded.</strong>
      <div class="mt-2 small">
        Please confirm all or cancel tentative awards before sending award notification to this supplier.
      </div>
    </div>

    <!-- Tentatively Awarded Locations -->
    <div class="card mb-3" *ngIf="validationTentativeCount > 0">
      <div class="card-header bg-warning text-dark">
        <h6 class="card-title mb-0">
          <ng-icon name="lucideClock" class="me-2"></ng-icon>
          Tentatively Awarded Locations ({{validationTentativeCount}})
        </h6>
      </div>
      <div class="table-responsive">
        <table class="table table-sm mb-0">
          <thead class="table-light">
            <tr>
              <th>Location</th>
              <th *ngIf="!tender?.company?.settings?.isHiddenField('location_company_info')">Company Info</th>
              <th *ngIf="!tender?.company?.settings?.isHiddenField('location_fuel_type')">Fuel Type</th>
              <th *ngIf="!tender?.company?.settings?.isHiddenField('location_flight_type')">Flight Type</th>
              <th>Awarded Contract Volume</th>
              <th>Contract Period</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let offer of getValidationTentativeOffers(); trackBy: trackByOffer">
              <td>
                <strong>{{offer.location_iata || 'N/A'}}</strong><br>
                <small class="text-muted">{{offer.location_name || 'N/A'}}</small>
              </td>
              <td *ngIf="!tender?.company?.settings?.isHiddenField('location_company_info')">
                {{offer.company_info || 'N/A'}}
              </td>
              <td *ngIf="!tender?.company?.settings?.isHiddenField('location_fuel_type')">
                <span class="">{{tender.company.settings.getFilteredOptionLabel('fuel_type', offer.fuel_type) ||
                  offer.fuel_type || 'N/A'}}</span>
              </td>
              <td *ngIf="!tender?.company?.settings?.isHiddenField('location_flight_type')">
                <span class="">{{offer.flight_type?.name || 'N/A'}}</span>
              </td>
              <td>
                <strong>{{getAwardedVolumeFormatted(offer)}}</strong><br>
                <small class="text-muted">{{offer.units?.code || ''}}</small>
              </td>
              <td>
                <div class="small">
                  <div><strong>Start:</strong> {{getContractStartDate(offer) || 'N/A'}}</div>
                  <div><strong>End:</strong> {{getContractEndDate(offer) || 'N/A'}}</div>
                </div>
              </td>
              <td>
                <span class="badge bg-warning text-dark">Tentative</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-light text-dark" (click)="modal.dismiss()">
      Close
    </button>
  </div>
</ng-template>

<!-- Cancel Award Modal -->
<ng-template #cancelAwardModal let-modal>
  <div class="modal-header bg-danger text-white">
    <h4 class="modal-title">Cancel Award</h4>
    <button type="button" class="btn-close btn-close-white" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <p class="mb-4">
      Are you sure you want to cancel the award for <strong>{{offerToCancel?.location_iata}}</strong>
      from <strong>{{offerToCancel?.supplier?.name}}<span *ngIf="offerToCancel?.supplier?.supplier_alias"> ({{offerToCancel?.supplier?.supplier_alias}})</span></strong>?
    </p>

    <!-- Location Information Card -->
    <div class="card mb-3">
      <div class="card-header bg-light">
        <h6 class="card-title mb-0">
          <ng-icon name="lucideMapPin" class="me-2"></ng-icon>
          Location Information
        </h6>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-3 mb-2">
            <div class="text-muted small">Location</div>
            <div class="fw-bold">{{offerToCancel?.location_name}}</div>
          </div>
          <div class="col-md-3 mb-2" *ngIf="!tender?.company?.settings?.isHiddenField('location_company')">
            <div class="text-muted small">Company Info</div>
            <div class="fw-bold">{{offerToCancel?.company_info || 'N/A'}}</div>
          </div>
          <div class="col-md-3 mb-2" *ngIf="!tender?.company?.settings?.isHiddenField('location_fuel_type')">
            <div class="text-muted small">Fuel Type</div>
            <div class="fw-bold">{{offerToCancel?.fuel_type?.name || offerToCancel?.fuel_type || 'N/A'}}</div>
          </div>
          <div class="col-md-3 mb-2" *ngIf="!tender?.company?.settings?.isHiddenField('location_flight_type')">
            <div class="text-muted small">Flight Type</div>
            <div class="fw-bold">{{offerToCancel?.flight_type?.name || offerToCancel?.flight_type || 'N/A'}}</div>
          </div>
          <div class="col-md-3 mb-2"
            *ngIf="!tender?.company?.settings?.isHiddenField('location_delivery_point')">
            <div class="text-muted small">Preferred Delivery Point</div>
            <div class="fw-bold">{{offerToCancel?.delivery_point || 'N/A'}}</div>
          </div>
          <div class="col-md-3 mb-2">
            <div class="text-muted small">Total Volume</div>
            <div class="fw-bold">{{$safeNavigationMigration(offerToCancel?.volume) | number:'1.0-0'}} {{offerToCancel?.units?.code}}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- Supplier Award Information Card -->
    <div class="card mb-3">
      <div class="card-header bg-light">
        <h6 class="card-title mb-0">
          <ng-icon name="lucideBuilding2" class="me-2"></ng-icon>
          Supplier Award Information
        </h6>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-3 mb-2">
            <div class="text-muted small">Supplier</div>
            <div class="fw-bold">{{getSupplierGroupForOffer(offerToCancel)?.supplier?.name || 'N/A'}}<span *ngIf="getSupplierGroupForOffer(offerToCancel)?.supplier?.supplier_alias"> ({{getSupplierGroupForOffer(offerToCancel)?.supplier?.supplier_alias}})</span></div>
          </div>
          <div class="col-md-3 mb-2">
            <div class="text-muted small">Awarded Contract Volume</div>
            <div class="fw-bold">{{$safeNavigationMigration(offerToCancel?.awarded_volume) | number:'1.0-0'}} {{offerToCancel?.units?.code}}</div>
          </div>
          <div class="col-md-3 mb-2">
            <div class="text-muted small">Award Percentage</div>
            <div class="fw-bold">{{offerToCancel?.awarded_percent}}%</div>
          </div>
          <div class="col-md-3 mb-2">
            <div class="text-muted small">Contract Type</div>
            <div class="fw-bold">{{offerToCancel?.contract_type}}</div>
          </div>
          <div class="col-md-3 mb-2">
            <div class="text-muted small">Contract Start</div>
            <div class="fw-bold">{{getContractStartDate(offerToCancel)}}</div>
          </div>
          <div class="col-md-3 mb-2">
            <div class="text-muted small">Contract End</div>
            <div class="fw-bold">{{getContractEndDate(offerToCancel)}}</div>
          </div>
        </div>
      </div>
    </div>

    <ng-container *ngTemplateOutlet="awardCommentReadOnly; context: {$implicit: offerToCancel}"></ng-container>

    <div class="alert alert-danger">
      <p><ng-icon name="lucideTriangleAlert" class="me-2"></ng-icon> <strong>Warning:</strong> This will revert the
        offer back to 'Received' status.</p>
      <p>The offer can be then re-awarded. If the round is still active, the supplier can edit and resubmit their offer.</p>
        <p class="mb-0">Supplier will be automatically notified via emailed daily summary.</p>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-light me-3" (click)="modal.dismiss()"
      [disabled]="cancellingAward">Cancel</button>
    <button type="button" class="btn btn-danger" (click)="cancelAwardAction()" [disabled]="cancellingAward">
      <span *ngIf="cancellingAward">
        <div class="spinner-border spinner-border-sm me-1" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        <span>Cancelling...</span>
      </span>
      <span *ngIf="!cancellingAward">Cancel Award</span>
    </button>
  </div>
</ng-template>

<!-- Confirmation-reminder modal -->
<ng-template #confirmationReminderModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">
      <ng-icon name="lucideMailCheck" class="me-2"></ng-icon>
      Send confirmation reminder
    </h5>
    <button type="button" class="btn-close" (click)="modal.dismiss(false)"></button>
  </div>
  <div class="modal-body">
    <p class="mb-2">
      Send an instant email to <strong>{{ unconfirmedSupplierCount }}</strong>
      supplier{{ unconfirmedSupplierCount === 1 ? '' : 's' }} asking them to confirm
      the awards on their side.
    </p>
    <p class="text-muted small mb-3">
      The email lists each supplier's awarded locations and walks them through the
      three-step sign-off on the tender-results page.
    </p>

    <div *ngIf="lastReminderRelative" class="alert alert-warning small mb-0 py-2">
      <ng-icon name="lucideTriangleAlert" class="me-1"></ng-icon>
      A reminder was already sent <strong>{{ lastReminderRelative }}</strong>.
      Send another?
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-light" (click)="modal.dismiss(false)">Cancel</button>
    <button type="button" class="btn btn-primary" (click)="modal.close(true)">
      Send reminder
    </button>
  </div>
</ng-template>

<!-- Pagination Controls -->
<div *ngIf="totalItems > pageSize" class="row">
  <div class="col-12 px-md-2">
    <div class="card bg-white">
      <div class="card-footer bg-white border-top">
        <div class="d-flex justify-content-between align-items-center">
          <div class="pagination-info">
            <small class="text-muted">
              Showing {{ startIndex }} to {{ endIndex }} of {{ totalItems }} supplier groups
            </small>
          </div>
          <div class="d-flex align-items-center gap-3">
            <div class="page-size-selector">
              <label class="form-label small mb-0 me-2">Items per page:</label>
              <select class="form-select form-select-sm" style="width: auto;" [(ngModel)]="pageSize"
                (ngModelChange)="onPageSizeChange($event)">
                <option value="5">5</option>
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="50">50</option>
              </select>
            </div>
            <ngb-pagination [(page)]="currentPage" [pageSize]="pageSize" [collectionSize]="totalItems" [maxSize]="5"
              [rotate]="true" [boundaryLinks]="true" (pageChange)="onPageChange($event)">
            </ngb-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Award comment, read-only. Used by the modals that only show award details. -->
<ng-template #awardCommentReadOnly let-offer>
  <div class="card mb-3" *ngIf="offer?.award_comment">
    <div class="card-header bg-light d-flex align-items-center">
      <h6 class="card-title mb-0 flex-grow-1">
        <ng-icon name="lucideMessageSquare" class="me-2"></ng-icon>
        Award Comment
      </h6>
      <span class="badge bg-warning-subtle text-dark border border-warning-subtle fw-normal">
        Visible to the supplier
      </span>
    </div>
    <div class="card-body">
      <div style="white-space: pre-line;">{{offer.award_comment}}</div>
    </div>
  </div>
</ng-template>
